export default __webpack_public_path__ + "static/media/logo.693a6673.png";